module.exports = __webpack_public_path__ + "img/matrix_rate_icon.16f9d84d.png";